import { all }                              from 'redux-saga/effects';
import productDomainAsyncInterface          from './products/saga';
import accountDomainAsyncInterface          from './sign-in/saga';
import blogDomainAsyncInterface             from './blog/saga';

export default function* domainSaga() {
    yield all([
        accountDomainAsyncInterface(),
        productDomainAsyncInterface(),
        blogDomainAsyncInterface()
    ])
}